import { api } from '@/core/helpers/axiosHelper';

export default {
   async getAccessToken() {
      return api.get('/powerbi/accesstoken').then((response) => {
         return response?.data;
      });
   },
};
